<p-toast></p-toast>
<app-page-shell>
  <app-page-hero eyebrow="Company setup" title="Tenant master-data import"
    subtitle="Import company, fleet, warehouse, contract, and pricing records. Review every row before confirming."></app-page-hero>
  <app-page-data-panel title="Upload workbook">
    <div class="upload-grid">
      <div class="file-field"><p-inputGroup><p-inputGroupAddon><i
              class="pi pi-file-excel"></i></p-inputGroupAddon><p-fileUpload name="tenantMasterDataWorkbook"
            mode="basic" chooseLabel="Choose completed workbook" chooseIcon="pi pi-cloud-upload" accept=".xlsx"
            [maxFileSize]="20971520" [customUpload]="true" (onSelect)="onFileSelected($event)"
            styleClass="master-file-upload"></p-fileUpload></p-inputGroup><small><i class="pi pi-info-circle"></i> {{
          file?.name || 'CargoMate_Tenant_Master_Data_Collection.xlsx only, maximum 20 MB.' }}</small></div>
      <div class="template-action"><p-button label="Download template" icon="pi pi-download" severity="secondary"
          [outlined]="true" [loading]="downloading" [disabled]="downloading"
          (click)="downloadTemplate()"></p-button><small><i class="pi pi-file-excel"></i> Get the
          latest CargoMate workbook.</small></div>
      <div class="upload-actions"><p-button label="Validate only" icon="pi pi-check-circle" severity="secondary"
          [loading]="uploading" (click)="upload()"></p-button><small><i class="pi pi-shield"></i> Creates no master
          data.</small></div>
    </div>
  </app-page-data-panel>
  <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>
  @if (current) {
  <app-page-data-panel title="Import review">
    <div class="review-actions"><p-tag [value]="current.batch.status"
        [severity]="severity(current.batch.status)"></p-tag><span>{{ current.batch.fileName }}</span><span
        class="spacer"></span><p-button label="Export issues" icon="pi pi-file-export" severity="secondary"
        [disabled]="!issueRows.length" (click)="exportIssues()"></p-button><p-button
        [label]="current.batch.status === 'FAILED' ? 'Retry failed rows' : 'Create / update master data'"
        icon="pi pi-check" [disabled]="!canProcess" (click)="confirmVisible = true"></p-button></div>
    @if (current.batch.invalidRows > 0) { <p class="issue-note">Correct the source workbook and upload a new batch
      before importing.</p> }
    @if (current.batch.failedRows > 0) { <p class="issue-note">Saved rows stay in place. Retry failed rows after
      resolving their issues.</p> }
    <p-inputGroup class="filter-input"><p-inputGroupAddon><i
          class="pi pi-search"></i></p-inputGroupAddon><p-iftalabel><input id="validationIssueFilter" pInputText
          [(ngModel)]="errorFilter"><label for="validationIssueFilter">Filter rows</label></p-iftalabel></p-inputGroup>
    <p-table [value]="reviewRows" [paginator]="true" [rows]="10">
      <ng-template #header>
        <tr>
          <th>Sheet</th>
          <th>Row</th>
          <th>External code</th>
          <th>Status</th>
          <th>Saved ID</th>
          <th>Issue</th>
        </tr>
      </ng-template>
      <ng-template #body let-row>
        <tr>
          <td>{{ row.sheetName }}</td>
          <td>{{ row.rowNumber }}</td>
          <td>{{ row.externalCode || '—' }}</td>
          <td><p-tag [value]="row.status" [severity]="severity(row.status)"></p-tag></td>
          <td>{{ row.createdEntityId || '—' }}</td>
          <td>{{ row.errorMessage || '—' }}</td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td colspan="6">No rows match this filter.</td>
        </tr>
      </ng-template>
    </p-table>
  </app-page-data-panel>
  }
  <app-page-data-panel title="Recent import batches">
    <p-table [value]="batches" [paginator]="true" [rows]="8"><ng-template #header>
        <tr>
          <th>Workbook</th>
          <th>Created</th>
          <th>Status</th>
          <th>Rows</th>
          <th></th>
        </tr>
      </ng-template><ng-template #body let-batch>
        <tr>
          <td>{{ batch.fileName }}</td>
          <td>{{ batch.createdAt | date:'medium' }}</td>
          <td><p-tag [value]="batch.status" [severity]="severity(batch.status)"></p-tag></td>
          <td>{{ batch.successRows || 0 }} saved / {{ batch.failedRows || 0 }} failed / {{ batch.totalRows }} total</td>
          <td><p-button label="Review" severity="secondary" size="small" (click)="openBatch(batch)"></p-button></td>
        </tr>
      </ng-template></p-table>
  </app-page-data-panel>
</app-page-shell>
<p-dialog header="Confirm master-data import" [(visible)]="confirmVisible" [modal]="true"
  [style]="{ width: '36rem', maxWidth: 'calc(100vw - 2rem)' }" styleClass="master-import-dialog">
  <div class="import-dialog-body">
    <aside class="import-dialog-summary"><i class="pi pi-file-import"></i>
      <div><small>Company setup</small>
        <h3>{{ current?.batch?.fileName }}</h3>
        <p>Successful rows stay saved if another row fails.</p>
      </div>
    </aside>
    <div class="import-dialog-card">
      <p>Supported rows will be created or updated in dependency order. CRM business roles and company login roles will
        be applied from the workbook.</p>
      <p>A setup email will be requested for each new login after its account is saved.</p>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="dialog-actions"><p-button label="Cancel" severity="secondary"
        (click)="confirmVisible = false"></p-button><p-button
        [label]="current?.batch?.status === 'FAILED' ? 'Retry failed rows' : 'Confirm import'" icon="pi pi-check"
        [loading]="processing" (click)="process()"></p-button></div>
  </ng-template>
</p-dialog>
